import isMobile from 'is-mobile';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Link, rem, StyleProps, Text, VStack } from '@bonusly/design-system';

import { detectProviderFromUrl, PROVIDER_CONFIG } from '../../../../../../lib/gif-provider';
import { GenericAttachment } from '../../../types/generic-attachment';
import { ImageOrVideo } from './image-or-video';

interface Props extends StyleProps {
	images: GenericAttachment[];
	variant?: string;
}

export const ImageList: FC<Props> = ({ images, ...rest }) => {
	const { t } = useTranslation('recognition');
	// We need to filter out the images that don't have a gif or mp4 a.k.a. the entry is a recorded video
	const filteredImages = images.filter((image) => image.gif || image.mp4);

	if (!filteredImages?.length) {
		return null;
	}

	return (
		<VStack {...rest} alignItems="flex-start" rowGap={3}>
			{images.map((image, index) => {
				const src = isMobile() ? image.gif : image.mp4;
				const provider = detectProviderFromUrl(src);
				const providerConfig = provider ? PROVIDER_CONFIG[provider] : null;

				return (
					<Box key={index} position="relative" display="inline-block">
						<ImageOrVideo alt={image.alt_text || t('bonus_card.attachment')} borderRadius="md" maxH={rem(512)} src={src} />
						{providerConfig && (
							<Box position="absolute" bottom={2} right={2} bg="blackAlpha.700" px={2} py={1} borderRadius="md">
								<Text fontSize="xs" color="whiteAlpha.800">
									{t('bonus_card.powered_by')}{' '}
									<Link href={providerConfig.url} isExternal fontWeight="semibold" color="white">
										{providerConfig.name}
									</Link>
								</Text>
							</Box>
						)}
					</Box>
				);
			})}
		</VStack>
	);
};
